import { Search } from 'lucide-react';
import { getApexReference } from '../lib/jobReference';

export const ApexReference = ({ job, scope }) => (
  <span className="apex-reference" data-testid={`apex-reference-${scope}-${job.id}`}>
    {getApexReference(job) || 'No ref'}
  </span>
);

export const JobSearch = ({ value, onChange, scope }) => (
  <label className="job-search">
    <Search size={18} aria-hidden="true" />
    <span className="sr-only">Search by Apex reference or customer name</span>
    <input type="search" className="retro-input" data-testid={`${scope}-job-search`} value={value}
      onChange={e => onChange(e.target.value)} placeholder="Reference or customer name" />
  </label>
);